/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useMemo } from 'react'
import { withTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import styles from './ReviewConfirmation.module.scss'
import { postTransactionAction } from 'redux/reducers/apiReducers/postTransactionReducer'
import { screenLoadingAction } from 'redux/actions'
import CurrentAddressSummary from './CurrentAddressSummary';
import ContactInformationSummary from './ContactInformationSummary'
import NewAddressSummary from './NewAddressSummary'
import JointlyOwnedVehicleListTable from '../../JointlyOwnedVehicleInformation/components/summary/JointlyOwnedVehicleListTable'
import BusinessVehicleListTable from '../../BusinessVehicleInformation/components/summary/BusinessVehicleListTable'
import HouseholdListTable from '../../HouseholdList/components/HouseholdListTable'
import ContinueCancelButtons from '../../../../shared/components/ContinueCancelButtons'
import BackAnchor from '../../../../shared/components/BackAnchor'


const ReviewConfirmationView = ({ t, i18n, setIsError }) => {
  const [confirmChecked, setConfirmChecked] = useState(false)
  const [checkboxMessage, setCheckbocMessage] = useState(false)
  const [errMsg, setErrMsg] = useState('')
  const dispatch = useDispatch()
  const history = useHistory()

  const userIdentifier = useSelector((state) => state.register.uniqueID)
  const { email } = useSelector((state) => state.app.contactInformation)
  const { jointlyRegistered, nsHealthCard, registeredBusiness, driverLicence, registeredByName } = useSelector((state) => state.app.addressTypeChange)

  const isRMV = useMemo(() => {
    return driverLicence || registeredByName || jointlyRegistered || registeredBusiness
  }, [driverLicence, registeredByName, jointlyRegistered, registeredBusiness]);

  const appData = useSelector((state) => state.app);
  // useEffect(() => {
  //   try {
  //     if (!fullName || !masterNumber) {
  //       // history.push(`/${i18n.language}${t('routes.your_info')}`)
  //     }
  //     else {
  //       console.log("TODO: FILL")
  //       // dispatch(editFromConfirmationAction(false));
  //     }
  //   } catch (e) {
  //     console.log(e)
  //     setIsError(true)
  //   }
  // }, [])


  const getTransactionData = () => {
    try {
      const businessData = {
        addressTypeChange: appData.addressTypeChange,
        addressesToChange: appData.addressesToChange,
        currentAddress: appData.currentAddress,
        newAddress: appData.newAddress,
        contactInformation: appData.contactInformation,
        newAddressEffective: appData.newAddressEffective,
        businessVehicleInformation: appData.businessVehicleInformation.businessVehicles,
        jointlyOwnedVehicleInformation: appData.jointlyOwnedVehicleInformation.vehicles,
        personalInformation: appData.personalInformation.houseHoldMembers,
      }

      const data = {
        businessData: JSON.stringify(businessData),
        businessServiceType: 'ADDRESSUPDATE',
        lang: i18n.language.toString(),
        useridentifier: userIdentifier.toString()
      }
      return data
    } catch (err) {
      dispatch(screenLoadingAction())
      console.log(err)
      throw err
    }
  }

  const onContinueClick = () => {
    try {
      if (confirmChecked) {
        setCheckbocMessage(false)
        dispatch(screenLoadingAction())
        dispatch(postTransactionAction(getTransactionData()))
          .then((res) => {
            let transId = res['data']['id']
            let uuid = res['data']['useridentifier']
            dispatch(screenLoadingAction())
            history.push(`/${i18n.language}${t('routes.receive_confirmation')}/${transId}/${uuid}`)
            // window.location.assign(`${window.location.origin}${paymentURL}`)
          })
          .catch((e) => {
            dispatch(screenLoadingAction())
            console.log(e)
            setErrMsg('review_confirmation.server_error')
          })
      } else {
        setCheckbocMessage(true)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  // const backNextProps = {
  //   prevText: t('review_confirmation.back'),
  //   prevURL: `/${i18n.language}${t('routes.contact_info')}`,
  //   nextText: t('review_confirmation.proceed_to_payment'),
  // }

  return (
    <div>
      <div className="container">
        <div className="row">
          <BackAnchor />
        </div>
        <div className="row">
          <div className="col-xs-12">
            <h1>{t('review_summary.title')}</h1>
          </div>
        </div>

        <div className={styles['content_margin']}>
          <CurrentAddressSummary />
        </div>
        <div className={styles['content_margin']}>
          <NewAddressSummary />
        </div>
        {(isRMV || nsHealthCard) && (
          <div className={styles['content_margin']}>
            <HouseholdListTable isSummary={true} />
          </div>
        )}

        {jointlyRegistered && (
          <div className={styles['content_margin']}>
            <JointlyOwnedVehicleListTable isSummary={true} />
          </div>
        )}

        {registeredBusiness && (
          <div className={styles['content_margin']}>
            <BusinessVehicleListTable isSummary={true} />
          </div>
        )}


        <div className={styles['content_margin']}>
          <ContactInformationSummary />
        </div>

        {/* <div className="row">
          <div className="col-xs-12 col-lg-12">
            <h3>{t('review_confirmation.contact_information')}</h3>
            <p>
              {t('review_confirmation.your_transaction_details')}<br /><strong>{email}</strong>
            </p>
          </div>
        </div> */}
        <div className="row">
          <div className="col-xs-12 col-lg-12">
            <h3>{t('review_confirmation.confirmation')}</h3>
            <p>{t('review_confirmation.please_verify')}</p>
            <p>{t('review_confirmation.your_confirmation')}</p>
            <ul>
              <li>{t('review_confirmation.you_consent_to')}</li>
              <li>
                {t('review_confirmation.you_are_in_agreement')}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={
                    i18n.language === 'en'
                      ? 'https://novascotia.ca/sns/services/help/terms-of-use.asp'
                      : 'https://novascotia.ca/sns/services/help/terms-of-use-fr.asp'
                  }
                >
                  {t('review_confirmation.terms_of_use')}
                  <span className="ns-visually-hidden">(opens in a new tab)</span>
                </a>
                {t('review_confirmation.for_this_transaction')}
              </li>
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-lg-12">
            <label className="confirm_check_input" htmlFor="ConfirmationCheckBox">
              <input
                type="checkbox"
                id="ConfirmationCheckBox"
                value="confirm_check"
                onChange={(e) => {
                  setConfirmChecked(e.currentTarget.checked)
                }}
                onBlur={() => {
                  confirmChecked ? setCheckbocMessage(false) : setCheckbocMessage(true)
                }}
                checked={confirmChecked}
              />
              &nbsp;
              {t('review_confirmation.yes_information_is_correct')}&nbsp;
              {checkboxMessage ? (
                <i aria-label={t('shared.error')} className={['fa fa-exclamation-circle', styles['exclamation_color']].join(' ')} aria-hidden="true"></i>
              ) : (
                ''
              )}
            </label>
            {checkboxMessage ? (
              <div className="form-group has-error">
                <div className="help-block">{t('review_confirmation.confirm_check_error')}</div>
              </div>
            ) : null}
          </div>
        </div>
        <div className={styles['error_margin']}>
          <ContinueCancelButtons continueClick={onContinueClick} />
          {/* <BackNextButtons props={backNextProps} nextOnClick={confirmationClick} /> */}
          {errMsg === '' ? null : (
            <i
              className={['fa fa-exclamation-circle', styles['exclamation_position'], styles['exclamation_color']].join(' ')}
              aria-hidden="true"
            />
          )}
        </div>
        {errMsg === '' ? null : (
          <div className={styles['error_message']}>
            <div className="form-group has-error">
              <div className="help-block">{t(errMsg)}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default withTranslation('common')(ReviewConfirmationView)
